import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_HERIDENTIFICATIE: MijnRoute = {
    path: 'heridentificatie',
    navigationEvent: 'toHeridentificatie',
    regex: /^\/zelf-regelen\/heridentificatie$/,
    webcomponent: 'mijn-klant-heridentificatie-webcomponent'
};
